import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import Login from './pages/Login';
import AccessDenied from './pages/AccessDenied';

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading, authRequired, unauthorized } = useAuth();

  // Show loading state
  if (loading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        fontSize: '18px',
        color: '#666'
      }}>
        Loading...
      </div>
    );
  }

  // If user is unauthorized, show access denied page
  if (unauthorized) {
    return <AccessDenied />;
  }

  // If auth is not required, show the content
  if (!authRequired) {
    return children;
  }

  // If auth is required and user is not authenticated, show login
  if (!isAuthenticated) {
    return <Login />;
  }

  // User is authenticated, show the protected content
  return children;
};

export default ProtectedRoute;
